import React from 'react';
import PropTypes from 'prop-types';

export const IconRecommended = ({ className }) => (
  <svg className={className} width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className="icon-filled-path" d="M25.4238 9.68523H17.9395L18.1749 6.39844C18.2496 5.35491 17.8466 4.31858 17.0691 3.55518C15.0457 1.56848 11.4546 2.12982 10.2698 4.63658L7.88335 9.68523H1.87734C1.39277 9.68523 1 10.0464 1 10.4918V24.8384C1 25.2838 1.39277 25.645 1.87734 25.645H8.45867C8.91198 25.645 9.28484 25.3289 9.33107 24.9234H16.3308C21.3596 24.9234 25.8352 21.9854 27.4679 17.6126L28.8031 14.0367C29.5992 11.9047 27.8825 9.68523 25.4238 9.68523ZM2.75467 11.2984H7.58133V24.0318H2.75467V11.2984ZM27.1436 13.5129L25.8083 17.0889C24.4189 20.8101 20.6101 23.3102 16.3307 23.3102H9.336V10.6595L11.8791 5.27949C12.2558 4.48227 13.1102 3.96715 14.0557 3.96715C15.421 3.96715 16.5147 5.02506 16.4239 6.29248L16.127 10.4389C16.0938 10.9035 16.4949 11.2984 17.0025 11.2984H25.4238C26.6715 11.2984 27.5497 12.4252 27.1436 13.5129Z" fill="#898989" stroke="#898989" strokeWidth="0.7" />
  </svg>
);

IconRecommended.propTypes = {
  className: PropTypes.string,
};

IconRecommended.defaultProps = {
  className: '',
};
